// extracted by mini-css-extract-plugin
export var attachmentContainer = "_m4-0";
export var fileList = "_m4-2";
export var removeFileButton = "_m4-1";